import { render, staticRenderFns } from "./state-details.vue?vue&type=template&id=1315ff5b&"
import script from "./state-details.vue?vue&type=script&lang=js&"
export * from "./state-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports